// import React, { useState } from "react";

// const SortBy = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [selectedOption, setSelectedOption] = useState("Relevance");

//   const toggleModal = () => setIsOpen(!isOpen);

//   const handleOptionClick = (option) => {
//     setSelectedOption(option);
//     toggleModal();
//   };

//   return (
//     <div className="relative">
//       <button
//         onClick={toggleModal}
//         className="px-4 py-2 bg-[#FF9630] text-white rounded-md"
//       >
//         Sort By
//       </button>

//       {isOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//           <div className="bg-white w-4/5 max-w-sm rounded-lg shadow-lg">
//             {/* Header */}
//             <div className="flex items-center justify-between p-4 border-b">
//               <h2 className="text-lg font-medium">Sort By</h2>
//               <button
//                 onClick={toggleModal}
//                 className="text-gray-600 hover:text-gray-900"
//               >
//                 ✕
//               </button>
//             </div>

//             {/* Options */}
//             <div className="p-4">
//               {["Relevance", "Price High To Low", "Price Low To High"].map(
//                 (option) => (
//                   <div
//                     key={option}
//                     className="flex items-center justify-between py-2 cursor-pointer"
//                     onClick={() => handleOptionClick(option)}
//                   >
//                     <span
//                       className={`${
//                         selectedOption === option
//                           ? "text-[#FF9630] font-medium"
//                           : "text-gray-800"
//                       }`}
//                     >
//                       {option}
//                     </span>
//                     {selectedOption === option && (
//                       <span className="text-[#FF9630]">✔</span>
//                     )}
//                   </div>
//                 )
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SortBy;

// import React, { useState } from "react";

// const SortBy = ({ closeModal }) => {
//   const [selectedOption, setSelectedOption] = useState("Relevance");

//   const handleOptionClick = (option) => {
//     setSelectedOption(option);
//     closeModal(); // Close the modal when an option is selected
//   };

//   return (
//     <div className="fixed inset-0 z-50  flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white w-4/5 max-w-sm rounded-lg shadow-lg">
//         {/* Header */}
//         <div className="flex items-center justify-between p-4 border-b">
//           <h2 className="text-lg font-medium">Sort By</h2>
//           <button
//             onClick={closeModal} // Close the modal when clicked
//             className="text-gray-600 hover:text-gray-900"
//           >
//             ✕
//           </button>
//         </div>

//         {/* Options */}
//         <div className="p-4">
//           {["Relevance", "Price High To Low", "Price Low To High"].map(
//             (option) => (
//               <div
//                 key={option}
//                 className="flex items-center justify-between py-2 cursor-pointer"
//                 onClick={() => handleOptionClick(option)}
//               >
//                 <span
//                   className={`${
//                     selectedOption === option
//                       ? "text-[#FF9630] font-medium"
//                       : "text-gray-800"
//                   }`}
//                 >
//                   {option}
//                 </span>
//                 {selectedOption === option && (
//                   <span className="text-[#FF9630]">✔</span>
//                 )}
//               </div>
//             )
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SortBy;

// import React, { useState } from "react";

// const SortBy = ({ closeModal }) => {
//   const [selectedOption, setSelectedOption] = useState("Relevance");

//   const handleOptionClick = (option) => {
//     setSelectedOption(option);
//     closeModal(); // Close the modal when an option is selected
//   };

//   return (
//     <div className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white w-full max-w-full rounded-t-lg shadow-lg">
//         {/* Header */}
//         <div className="flex items-center justify-between p-4 border-b">
//           <h2 className="text-lg font-medium">Sort By</h2>
//           <button
//             onClick={closeModal} // Close the modal when clicked
//             className="text-gray-600 hover:text-gray-900"
//           >
//             ✕
//           </button>
//         </div>

//         {/* Options */}
//         <div className="p-4 max-h-[300px] overflow-y-auto">
//           {["Relevance", "Price High To Low", "Price Low To High"].map(
//             (option) => (
//               <div
//                 key={option}
//                 className="flex items-center justify-between py-2 cursor-pointer"
//                 onClick={() => handleOptionClick(option)}
//               >
//                 <span
//                   className={`${
//                     selectedOption === option
//                       ? "text-[#FF9630] font-medium"
//                       : "text-gray-800"
//                   }`}
//                 >
//                   {option}
//                 </span>
//                 {selectedOption === option && (
//                   <span className="text-[#FF9630]">✔</span>
//                 )}
//               </div>
//             )
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SortBy;

// import React, { useState, useEffect } from "react";

// const SortBy = ({ closeModal }) => {
//   const [selectedOption, setSelectedOption] = useState("Relevance");

//   // Prevent page scroll when modal is open
//   useEffect(() => {
//     document.body.style.overflow = "hidden"; // Disable scrolling
//     return () => {
//       document.body.style.overflow = "auto"; // Re-enable scrolling when modal is closed
//     };
//   }, []);

//   const handleOptionClick = (option) => {
//     setSelectedOption(option);
//     closeModal(); // Close the modal when an option is selected
//   };

//   return (
//     <div className="fixed bottom-0 left-0 w-full z-50 bg-black bg-opacity-50">
//       <div className="bg-white w-full p-4 rounded-t-lg shadow-lg">
//         {/* Header */}
//         <div className="flex items-center justify-between p-4 border-b">
//           <h2 className="text-lg font-medium">Sort By</h2>
//           <button
//             onClick={closeModal} // Close the modal when clicked
//             className="text-gray-600 hover:text-gray-900"
//           >
//             ✕
//           </button>
//         </div>

//         {/* Options */}
//         <div className="p-4">
//           {["Relevance", "Price High To Low", "Price Low To High"].map(
//             (option) => (
//               <div
//                 key={option}
//                 className="flex items-center justify-between py-2 cursor-pointer"
//                 onClick={() => handleOptionClick(option)}
//               >
//                 <span
//                   className={`${
//                     selectedOption === option
//                       ? "text-[#FF9630] font-medium"
//                       : "text-gray-800"
//                   }`}
//                 >
//                   {option}
//                 </span>
//                 {selectedOption === option && (
//                   <span className="text-[#FF9630]">✔</span>
//                 )}
//               </div>
//             )
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SortBy;



// import React, { useState, useEffect } from "react";

// const SortBy = ({ closeModal }) => {
//   const [selectedOption, setSelectedOption] = useState("Relevance");

//   // Prevent page scroll when modal is open
//   useEffect(() => {
//     document.body.style.overflow = "hidden"; // Disable scrolling
//     return () => {
//       document.body.style.overflow = "auto"; // Re-enable scrolling when modal is closed
//     };
//   }, []);

//   const handleOptionClick = (option) => {
//     setSelectedOption(option);
//     closeModal(); // Close the modal when an option is selected
//   };

//   return (
//     <div className="fixed bottom-0 left-0 w-full z-50 bg-black bg-opacity-50">
//       <div className="bg-white w-full p-4 rounded-t-lg shadow-lg">
//         {/* Header */}
//         <div className="flex items-center justify-between p-4 border-b">
//           <h2 className="text-lg font-medium">Sort By</h2>
//           <button
//             onClick={closeModal} // Close the modal when clicked
//             className="text-gray-600 hover:text-gray-900"
//           >
//             ✕
//           </button>
//         </div>

//         {/* Options */}
//         <div className="p-4">
//           {["Relevance", "Price High To Low", "Price Low To High"].map(
//             (option) => (
//               <div
//                 key={option}
//                 className="flex items-center justify-between py-2 cursor-pointer"
//                 onClick={() => handleOptionClick(option)}
//               >
//                 <span
//                   className={`${
//                     selectedOption === option
//                       ? "text-[#FF9630] font-medium"
//                       : "text-gray-800"
//                   }`}
//                 >
//                   {option}
//                 </span>
//                 {selectedOption === option && (
//                   <span className="text-[#FF9630]">✔</span>
//                 )}
//               </div>
//             )
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SortBy;

import React, { useState, useEffect } from "react";

const SortBy = ({ closeModal }) => {
  const [selectedOption, setSelectedOption] = useState("Relevance");

  // Prevent page scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden"; // Disable scrolling
    return () => {
      document.body.style.overflow = "auto"; // Re-enable scrolling when modal is closed
    };
  }, []);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    closeModal(); // Close the modal when an option is selected
  };

  return (
    <div className="fixed bottom-0 left-0 w-full z-50 bg-black bg-opacity-50">
      <div className="bg-white w-full p-4 rounded-t-lg shadow-lg">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-medium">Sort By</h2>
          <button
            onClick={closeModal} // Close the modal when clicked
            className="text-gray-600 hover:text-gray-900"
          >
            ✕
          </button>
        </div>

        {/* Options */}
        <div className="p-4">
          {["Relevance", "Price High To Low", "Price Low To High"].map(
            (option) => (
              <div
                key={option}
                className="flex items-center justify-between py-2 cursor-pointer"
                onClick={() => handleOptionClick(option)}
              >
                <span
                  className={`${
                    selectedOption === option
                      ? "text-[#FF9630] font-medium"
                      : "text-gray-800"
                  }`}
                >
                  {option}
                </span>
                {selectedOption === option && (
                  <span className="text-[#FF9630]">✔</span>
                )}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default SortBy;
